'use strict';

// todo deprecated - заменить на виджет
(function ($) {
    let rangeSlideDelay = 500;
    $(document).on('mousedown', '.input-range-slider-slide', function (event) {
        const $this = $(this);

        if (!$this.closest('.fotobook-range-slider').length) {
            return;
        }
        const widget = $this.siblings('.input-range-slider').data('ui-slider');

        let oldValue;
        let newValue;

        const rangeSliderSlide = function () {
            var rangeSliderTimeOut = $this.siblings('.input-range-slider').data('ui-slider-timeout');
            //Изменять значение слайдера "Прозрачность" и "Масштаб" при зажатии кнопок "+"/"-"
            oldValue = widget.value();

            if ($this.hasAttr('data-set')) {
                newValue = parseFloat($this.attr('data-set'));
            } else {
                var step;
                if ($this.hasAttr('data-step')) {
                    step = parseFloat($this.attr('data-step'));
                } else {
                    step = widget.option('step');
                    if ($this.hasClass('input-range-slider-minus')) {
                        step = -step;
                    }
                }
                newValue = oldValue + step;
            }
            newValue = Math.min(widget.option('max'), Math.max(newValue, widget.option('min')));
            if (newValue === oldValue) {
                return;
            }

            if (!widget) {
                return;
            }
            widget._slide(event, 0, newValue);
            if (rangeSliderTimeOut) {
                clearTimeout(rangeSliderTimeOut);
            }
            rangeSliderTimeOut = setTimeout(rangeSliderSlide, rangeSlideDelay);
            rangeSlideDelay = 50;
            $this.siblings('.input-range-slider').data('ui-slider-timeout', rangeSliderTimeOut);
        };


        if (
            !widget ||
            $this.hasClass('input-range-slider-minus') && widget.value() === widget.option('min') ||
            $this.hasClass('input-range-slider-plus') && widget.value() === widget.option('max')
        ) {
            return;
        }
        widget._start(event, 0);
        rangeSliderSlide();
    });

    $(document).on('mouseup mouseleave', '.input-range-slider-slide', function (event) {
        const $this = $(this);
        const $slider = $this.siblings('.input-range-slider');
        const widget = $slider.data('ui-slider');
        const rangeSliderTimeOut = $slider.data('ui-slider-timeout');

        if (widget && rangeSliderTimeOut) {
            clearTimeout(rangeSliderTimeOut);
            widget._stop(event, 0);
            $slider.data('ui-slider-timeout', false);
            rangeSlideDelay = 500;
        }
    });
})(jQuery);
